/**
 * Hook to access API configuration
 */

import { useMemo } from 'react';
import { getApiConfig } from '../config/api.config';

/**
 * Hook that provides the current API configuration
 * Useful for components that need to make direct API calls
 */
export function useApiConfig() {
  const config = useMemo(() => getApiConfig(), []);
  
  return config;
}

/**
 * Hook that provides just the API base URL
 */
export function useApiUrl() {
  const config = useApiConfig();
  return config.apiUrl;
}

/**
 * Hook that provides just the WebSocket URL
 */
export function useWsUrl() {
  const config = useApiConfig();
  return config.wsUrl;
}